import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import PrivatePopup from "../../Layouts/PrivateRouteLayouts/PrivatePopup";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getIndustrucatagoryforHire } from "../../../redux/hire/action";

export default function HireExpertsMainPage() {
  const path = "Assets/scss/hireexpert.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const indcat = useSelector(
    ({ hire: { getindustrucatagoryforhire } }) => getindustrucatagoryforhire,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getIndustrucatagoryforHire());
  }, []);

  const handleImageError = (e) => {
    e.target.src = `${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`;
  };

  return (
    <div className="hireexpert-main">
      <PrivatePopup indcat={indcat} />
      <div className="hire-first">
        <h2 className="font-42">Hire Experts / Company with the competencies you need</h2>
        {/* <div className=" col-md-5 mx-auto">
          <div className="search-bar">
            <input
              type="search"
              placeholder="Search by name, skills"
              className="form-control"
            />
            <button className="btn search-btn">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/search-btn.svg`}
                alt=""
              />
            </button>
          </div>
        </div> */}
      </div>
      <div className="col-lg-10 mx-auto">
        <div className="row hire-row">
          {Array.isArray(indcat) &&
            indcat?.map((ind, indindex) => (
              <div
                key={indindex}
                className="col-md-3 col-6"
                onClick={() =>
                  navigate(`/${lan}/hireexpertsbycategory/${ind?.id}`)
                }
              >
                <div className="hire-details">
                  {/* <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`}
                    className="w-100"
                    alt=""
                  /> */}
                  <img src={ind?.image} className="w-100"   onError={handleImageError}/>
                  <h6>{ind?.title}</h6>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
